<div class="parent d-flex align-items-center bg-white rounded-pill shadow py-1 pr-2 mt-4 mb-6">
  <i class="fa-regular fa-magnifying-glass p-3 h5 mb-0"></i>
  <input
    class="border-0 flex-grow-1 align-self-stretch"
    placeholder="Nach einem Unternehmen oder einer GP Nummer suchen"
    [formControl]="searchInput"
    [attr.data-test]="dataTestPageAttribute() + '-input-searchCompany'"
  />
  @if (isUserInput()) {
    <button
      id="reset-button-search-bar"
      class="btn flex-shrink-1 py-0 px-0 mr-2"
      (click)="reset()"
      [attr.data-test]="dataTestPageAttribute() + '-button-resetSearch'"
    >
      <i class="fa-regular fa-xmark h5 mb-0 black"></i>
    </button>
  }
  <button class="btn btn-primary--dark-blue flex-shrink-1 py-0 px-1 shadow" (click)="search()" [attr.data-test]="dataTestPageAttribute() + '-button-toggleSearch'">
    <i class="fa-regular fa-chevron-right p-3 h5 mb-0 white"></i>
  </button>
</div>
